<template>
<!-- 聊一聊页面 -->
<div style="height:100%">
  <div :class="['titles',{'titles-brush':brush}]">
    <div class="navigation" v-if="!brush">
      <span class="navigation-ite" :class="{'Highlight':HighlightIndex == ite.ind}" v-for="(ite,ind) in mainShowList" :key="ind" @click="preparation(ite.ind)">
        {{ite.name}}
      </span>
      <span :class="['navigation-more',{'navigation-more-hover':moreShowOrFalse}]" v-show="mainMoreShowList.length" @click="moreShowOrFalse = !moreShowOrFalse">
        <img src="" alt="">
        <ul v-show="moreShowOrFalse">
          <li v-for="(item,index) in mainMoreShowList" :key="index" :class="{'Highlight':HighlightIndex == item.ind}" @click="preparation(item.ind)">{{item.name}}</li>
        </ul>
      </span>
    </div>
    <!-- 搜索框 -->
    <div :class="['searchBox',{'drop':filterC}]" :style="brush?'':'margin-top:10px'">
      <span v-if="brush" :class="['screen',{'choose':filterC}]" @click="filter()">筛选</span>
      <input :style="brush?'':'width:calc(100% - 67px)'" placeholder="请输入关键字搜索" v-model="keyWord" @keyup.enter="hasKeyword=true;pageNum=1;getContent();contentArr=[];" />
      <span class="search" @click="hasKeyword=true;pageNum=1;getContent(brush?'change':'');contentArr=[];"></span>
      <div class="filterCriteria" v-show="filterC">
        <div class="filterCriteria-t clearfix">
          <div class="filterCriteria-t-scroll">
            <span :class="['filterCriteria-t-l',{'choose':filterContentS == ind}]" @click="topFilter(ind)" v-for="(ite,ind) in filterContent" :key="ind">{{ite}}</span>
          </div>
        </div>
        <!-- 展示分类、交付物分类 -->
        <ul class="filterCriteria-c clearfix" v-show="filterContentS > 2">
          <li :class="['filterCriteria-c-l',{'choose': ite.num == 3 ? ite.item : ( ite.num == 2 ? (showFilter == ite.code) : filterContentC == (ite.num == 1 ? (zzContent.length + ind) : ind)),'hover':ite.name == '暂无数据'}]" @click="centerFilter(ite,ind)" v-for="(ite,ind) in centerShow" :key="ind">{{ite.name}}</li>
        </ul>
        <!-- 组织、专项 -->
        <div class="filterCriteria-c clearfix" v-show="filterContentS > 0 && filterContentS < 3">
          <div v-for="(item,index) in centerShow" :key="index" style="display:flex;">
            <!-- <span class="filterCriteria-c-m" :style="'width:'+ maxWidth + 'px;'">{{item.name}} :</span> -->
            <ul>
              <li :class="['filterCriteria-c-l',{'choose': ite.num == iteNum && filterContentC == ind && filterContentD == index,'hover':ite.name == '暂无数据'}]" @click="centerFilter(ite,ind,index)" v-for="(ite,ind) in item.dataArr" :key="ind">{{ite.blockName}}</li>
            </ul>
          </div>
        </div>
        <div class="choose-content-box" v-show="filterContentS > 0">
          <div class="choose-title">已选择条件：</div>
          <ul class="clearfix">
            <li v-for="(item,index) in chooseContent"
                :key="index">
              <a href="javascript:;"
                 class="hover-systemBlue">{{item.name || item.userName}}</a>
              <span class="hover-systemBlue"
                    @click="del(item,index)">x</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- 展示框 -->
  <div :class="['topContent',{'topContent-null':nullImg,'topContent-brush':brush}]">
    <img :src="require('../assets/image/images/null_img.png')"
         alt=""
         v-show="nullImg">
    <em v-show="nullImg">
      <span>暂无数据,点击</span><span @click="reload">重新加载</span>
    </em>
    <div class="contentShow" :style="{'width':padd}">
      <div class="column" v-for="(column,index) in columns" :key="index">
        <div v-for="(ite,ind) in column.columnArr"
            :key="ind"
            class="item"
            draggable="true" @dragstart="dragss($event,ite)"
            @click="jumpFlow(ite)">
            <template v-if="ite">
              <special-offer :ite="ite&&ite.pData"></special-offer>
              <div :class="['brushImages',ite&&ite.pictures.length ? '':'back']">
                <ZImage :value="ite&&ite.pictures&&ite.pictures.length?ite.pictures[0]:''"
                        :error-src="require('../assets/image/images/default_media.png')"
                        :waterFull=true />
              </div>
              <div class="content">
                <span>{{ite&&ite.others&&ite.others[0].standardData?ite.others[0].standardData:''}}</span>
                <!-- <introduction v-if="ite&&ite.show" :contentId="ite.contentId"  @showOrFalse="ite.show = !ite.show"></introduction> -->
                <span v-if="ite&&ite.introduction">{{ite.introduction}}</span>
                <!-- 点赞栏 -->
                <fabulous :blockData="blockData" :ind="ind" :contentIds="ite&&ite.contentId" :contentWzUrl="ite&&ite.contentWzUrl" :ite="ite" :blockId="ite&&ite.blockId" :title="ite&&ite.others&&ite.others[0].standardData?ite.others[0].standardData:''" :standardJson="ite&&ite.standardJson" :zzblockId="chooseBusiness.num==0?chooseBusiness.id: (chooseBusiness.num ==1 ? '' : getQuery('zzBlockId'))" />
              </div>
          </template>
        </div>
      </div>
    </div>
    <div class="loading"
           v-show="loadingShow">
        <img :src="require('../assets/image/images/mxb.gif')"
             height="100%"
             alt="">
      </div>
  </div>
  </div>
</template>
<script>
import fabulous from "./fabulous.vue"
import introduction from "./introduction.vue"
import SpecialOffer from './specialOffer.vue'
import ZImage from "./ZImage.vue"

export default {
  name: 'deliverableDetail',
  components: {
    ZImage,
    fabulous,
    introduction,
    SpecialOffer,
  },
  props:{
    blockData:Object
  },
  data () {
    return {
      area:-1,
      suspend:false,
      overContent:[],
      now: '0',
      width: 0,
      speed: 0,
      marginLeft: 0,
      contentArr: [],
      columns: [],
      arrIndex:[],
      contentArr2:[],
      pageNum: 1,
      startY: 0,
      endY: 0,
      loadingShow: false,
      loadEnd: true,
      nullImg: false,
      contentss:[{name:'中机知道'},{name:'百家印象'},{name:'抖变世界'},{name:'ZJ同屏'},{name:'同屏体验'},{name:'同屏直播'},{name:'今日资讯'},{name:'百家文库'},{name:'操作培训'},{name:'AI设备'}],
      sign:1,
      padd:'1000',
      numss: Math.floor(((document.documentElement.clientWidth || document.body.clientWidth - 10 + 20)/320)) > 1 ? Math.floor(((document.documentElement.clientWidth || document.body.clientWidth - 10 + 20)/320)) : 1,
      keyWord:'',
      hasKeyword:false,
      navigationC:[{name:'全部',item:false,num:3,ind:0},{name:'视频',item:false,num:3,ind:1},{name:'音频',item:false,num:3,ind:3},{name:'图片',item:false,num:3,ind:4},{name:'文档',item:false,num:3,ind:8}],
      mainMoreShowList:[],
      Deliverables:[{name:'视频',item:false,num:3,ind:1},{name:'音频',item:false,num:3,ind:3},{name:'图片',item:false,num:3,ind:4},{name:'文档',item:false,num:3,ind:8}],
      mainShowList:[],
      wrapIndex:0,
      moreShowOrFalse:false,
      HighlightIndex:0,
      filterC:false,
      filterContent:['全部','组织身份','专项平台','展示分类','交付物分类'],
      filterContentS:0,
      iteNum:0,
      filterContentC:-1,
      filterContentD:-1,
      centerShow:[],
      // brush:this.getQuery('brush') == '2',
      brush:this.getQuery('brush'),
      pfId:this.getQuery('pfId'),
      zzContent:[{dataArr:[{blockName:'暂无数据',num:0}]}],
      zxContent:[{dataArr:[{blockName:'暂无数据',num:1}]}],
      zzMaxWidth:90,
      zxMaxWidth:90,
      maxWidth:50,
      chooseContent: [],
      showFilter: -1,
      thirdArray:[],
      chooseBusiness:{},
      chooseInd:this.getQuery('chooseInd'),
      chooseSort:this.getQuery('chooseSort'),
      serialize:this.getQuery('serialize')
    }
  },
  mounted () {
    var _this=this;
    if(_this.chooseInd && _this.chooseInd < 4){
      var ite = this.chooseSort == 3 ? [{name:'传媒',num:2,code:0},{name:'产品',num:2,code:1},{name:'直播',num:2,code:2}] : _this.Deliverables;
      _this.$nextTick(()=>{
        _this.filterContentS = this.chooseSort;
        _this.centerShow = ite;
        _this.centerFilter(ite[_this.chooseInd],_this.chooseInd)
      })
    }else{
      _this.getContent();
    }
    
    _this.computed();
    _this.mobile();
    if(_this.brush){
      _this.getFilter();
    }
    _this.findWrapIndex();
    const dom = document.querySelector('.topContent');
    dom.addEventListener('scroll', () => {
        const clientHeight = dom.clientHeight;
        const scrollTop = dom.scrollTop;
        const scrollHeight = dom.scrollHeight;
        const num = clientHeight + parseInt(scrollTop) - scrollHeight;
        if (num >= -1 && num <= 1 && _this.loadEnd && !_this.loadingShow && parseInt(scrollTop)) {
          _this.loadingShow = true;
          _this.pageNum++;
          _this.getContent();
        }
    })
    window.onresize = () =>{
      // 根据可视区域的宽度判断需要几列,假设图片宽度为240px
      _this.numss = Math.floor(((document.documentElement.clientWidth || document.body.clientWidth - 10 + 20)/320));
      if (_this.numss < 1) {
        _this.numss = 1;
      }
      _this.findWrapIndex();
    }
    document.querySelector('.topContent-brush').onscroll = function () {
      _this.filterC = false;
    }
    $(document).on('click touchstart',function(e) {
      //目标对象
      var object = $(e.target);
      if(object.closest(".searchBox").length == 0 && object.closest(".hover-systemBlue").length == 0){
        //点击除id为srdiv的元素
        _this.filterC = false;
      }
    })
    
  },
  activated () {
    const $content = document.querySelector('.topContent');
    $content.scrollTop = this.$route.meta.scrollTop
  },
  watch:{
    numss (news,old) {
      if(old != news){
        this.init(news);
      }
    }
  },
  methods: {
    dragss(ev,items){
      var ipcRender,wzUrl = items&&items.contentWzUrl?items.contentWzUrl :items.contentDsfWzUrl;
      if (navigator.userAgent.indexOf('Electron') > -1) {
        ev.preventDefault();
        ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
        ipcRender.send('startdrag',{'id':items.contentId,'fileName':items.standAllName?items.standAllName + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr'):'','url': wzUrl ? wzUrl : location.origin + '/uoqid?appId='+ items.appId +'&blockId='+ items.blockId +'&contentId='+ items.contentId +'&dataType=' + (items.sign ?  items.sign : 1)});
      }else{
        var desk = items.standAllName?items.standAllName:items.others[0].standardData;
        var text = JSON.stringify({ title: desk, url: wzUrl });  //要保存的内容
        var blob = new Blob([text], { type: "text/plain" });
        var anchor = window.URL.createObjectURL(blob);  //要保存的链接
        // 设置为文件类型
        ev.dataTransfer.setData("DownloadURL", 'text/plain:' + desk + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr') + ':' + anchor);
        ev.dataTransfer.setData("deviceId", JSON.stringify({id:items.contentId,checkedItemId:items.contentId,env:location.hostname}));
      }
    },
    scroll(){
      var box = document.querySelector('.filterCriteria-t-scroll');
      var x1,x2,l,flag,left; 
      function down(){
        flag = true;
        var e = window.event
        x1 = e.touches ? (e.touches[0].pageX) : e.clientX;
        left = parseInt(box.style.left) ? parseInt(box.style.left) : 0;
      }
      function move(){
        if(flag){
          var e = window.event
          x2 = e.touches ? (e.touches[0].pageX) : e.clientX;
          // 计算left
          l = x2 - x1 + left;
          if(l > 0){
            l = 0;
          }
          if(l<box.parentNode.offsetWidth - box.offsetWidth){
            l = box.parentNode.offsetWidth - box.offsetWidth + 8;
          }
          if(box.offsetWidth - box.parentNode.offsetWidth < 0) return;
          box.style.left = l + 'px';
        }
      }
      function end(){
        flag = false;
      }
      box.addEventListener("mousedown", down);
      box.addEventListener("mousemove", move);
      box.addEventListener("mouseup", end);
      box.addEventListener("touchstart", down);
      box.addEventListener("touchmove", move);
      box.addEventListener("touchend", end);
    },
    //排序
    sortTags (arr) {
      const _this = this;
      let cloneArr = arr.sort((a, b) => {
        return (b.length - a.length);
      })
      return cloneArr;
    },
    getFilter(){
      this.$http
        .get('/zciid-deliverable/api/browse/circleFriend.json', {
          pfId:this.pfId
        }).then(res => {
          if (res.state == 1 && res.data.length) {
            var arr = {}
            res.data.forEach((ite, ind) => {
              ite.num = 0
              ite.blockName = ite.userName
            })
            arr = { state: 1, dataArr: res.data }
            this.zzContent[0].dataArr = res.data
          }
        })
      this.$http
        .get('/zciid-deliverable/api/search/get/check/block.json', {
          pfId:this.pfId,
          types:'zx',
          dataType:'chat'
        }).then(res => {
          var arr = [];
          if(res.state == 1 && res.data.dataArr.length){
              res.data.dataArr.forEach((ite,ind)=>{
                ite.num = 1;
                ite.name = ite.blockName;
              })
            this.zxContent = [res.data];
          }
        })
    },
    //点击选择
    centerFilter(ite,ind,indes){
      if(ite.blockName == '暂无数据') return;
      //点击更改状态
      switch (ite.num){
        case 0 :
          this.centerShow = this.zzContent;
          this.iteNum = ite.num;
          this.filterContentC = ind;
          this.filterContentD = indes;
          this.chooseBusiness = ite;
          break;
        case 1 :
          this.centerShow = this.zxContent;
          this.iteNum = ite.num;
          this.filterContentC = ind;
          this.filterContentD = indes;
          this.chooseBusiness = ite;
          break;
        case 2 :
          this.showFilter = ite.code;
          break;
        case 3 :
          this.centerShow[ind].item = true;
          break;
      }
      //添加到已选择
      var index,showIndex;
      //找到已有下标
      for(var i = 0;i < this.chooseContent.length;i++){
        if(this.chooseContent[i].num < 2) {
          index = i;
        }
        if(this.chooseContent[i].num == 2){
          showIndex = i;
        }
      }
      if((index != undefined||ite.num == 2) && ite.num < 3){
        //前三个单选
        if(ite.num == 2){
          if(showIndex != undefined){
            if(this.chooseContent[showIndex].code == ite.code){
              //点击过清除
              this.chooseContent.splice(showIndex,1);
              this.filterContentC = -1;
              this.showFilter = -1;
            }else{
              //不同替换
              this.chooseContent.splice(showIndex,1,ite);
            }
          }else{
            //没有新增
            this.chooseContent.push(ite);
          }
          this.getContent('change',this.chooseContent.length && ite.code == 2 ? 'live' : '');
          return;
        }
        if((ite.id != undefined && this.chooseContent[index].id == ite.id) || (ite.userId != undefined && this.chooseContent[index].userId == ite.userId)){
          //重复点击去除状态
          this.filterContentC = -1;
          this.chooseBusiness = {};
          this.chooseContent.splice(index,1);
        }else{
          this.chooseContent.splice(index,1,ite);
        }
      }else {
        //多选
        var area = this.thirdArray.indexOf(ite.ind);
        if(ite.ind && area > -1){
          //已经被点击
          this.centerShow.filter(tag=>tag.ind == ite.ind)[0].item = false;
          this.thirdArray.splice(area,1);
          var ind = this.chooseContent.findIndex((tag)=> tag.ind == ite.ind);
          this.chooseContent.splice(ind,1);
        } else{
          if(ite.num < 2){
            this.chooseContent.unshift(ite);
          }
          if(ite.num > 2){
            //多选改单选
            if(this.thirdArray.length && this.thirdArray[0] != ite.ind){
              this.centerShow.filter(tag=>tag.ind == this.thirdArray[0])[0].item = false;
              this.thirdArray.splice(0,1,ite.ind);
              var ind = this.chooseContent.findIndex((tag)=> tag.ind == this.thirdArray[0]);
              this.chooseContent.splice(ind,1,ite);
            }else{
              this.thirdArray.push(ite.ind);
              this.chooseContent.push(ite);
            }
            
          }
        }
      }
      this.getContent('change');
    },
    topFilter(ind){
      this.filterContentS = ind;
      switch (ind){
        case 0 :
          this.centerShow = [];
          this.filterContentC = -1;
          this.chooseBusiness = {};
          this.thirdArray = [];
          if(this.chooseContent.length){
            this.showFilter = -1;
            this.Deliverables = [{name:'视频',item:false,num:3,ind:1},{name:'音频',item:false,num:3,ind:3},{name:'图片',item:false,num:3,ind:4},{name:'文档',item:false,num:3,ind:8}];
            this.chooseContent = [];
            this.getContent('change');
          }
          break;
        case 1 :
          this.centerShow = this.zzContent;
          this.maxWidth = this.zzMaxWidth;
          break;
        case 2 :
          this.centerShow = this.zxContent;
          this.maxWidth = this.zxMaxWidth;
          break;
        case 3 :
          this.centerShow = [{name:'传媒',num:2,code:0},{name:'产品',num:2,code:1},{name:'直播',num:2,code:2}];
          break;
        case 4 :
          this.centerShow = this.Deliverables;
          break;
      }
    },
    filter(){
      this.filterC = !this.filterC;
      if(this.filterC){
        this.$nextTick(()=>{
          this.scroll();
        })
      }
    },
    //删除选择
    del(item,index){
      if(item.num < 2){
        this.filterContentC = -1;
        this.chooseBusiness = {};
      }
      if(item.num == 2){
        var index = this.chooseContent.findIndex((tag)=> tag.num == 2);
        this.chooseContent.splice(index,1);
        this.showFilter = -1;
        this.getContent('change');
        return;
      }
      if(item.num == 3){
        this.Deliverables.filter(tag=>tag.ind == item.ind)[0].item = false;
        // this.Deliverables[item.ind].item = false;
        var ind = this.thirdArray.findIndex((tag)=> tag == item.ind);
        this.thirdArray.splice(ind,1);
      }
      this.chooseContent.splice(index,1);
      this.getContent('change');
    },
    preparation(ind){
      this.HighlightIndex = ind;
      this.contentArr = [];
      this.columns = [];
      this.pageNum = 1;
      this.nullImg = false;
      this.loadEnd = true;
      this.keyWord = "";
      this.getContent(ind);
    },
    findWrapIndex(){
      //计算能放几个优先级流程
      var width=0,wrapIndex=this.navigationC.length;
      for (let t = 0; t < this.navigationC.length; t++) {
        const spanWidths = this.navigationC[t].name.length * 14 + 30;
        width += spanWidths;
        if(width + 55 > window.innerWidth){
          wrapIndex = t;
          break;
        }
      }
      
      if(this.wrapIndex != wrapIndex){
        this.mainShowList = this.navigationC.slice(0,wrapIndex);
        this.mainMoreShowList = (this.navigationC.slice(wrapIndex,this.navigationC.length));
        if(!this.mainMoreShowList.length){
          //更新下拉框状态
          this.moreShowOrFalse = false;
        }
        this.wrapIndex = wrapIndex;
      }
    },
    reload(){
      location.reload();
    },
    changeColor(ind){
      this.area = ind;
    },
    mobile(){
      if(this.IsMobile()){
        var cWidth = document.documentElement.clientWidth || document.body.clientWidth;
        var num = Math.floor((cWidth - 60)/96);
        var content = this.contentss.slice(0,num);
        this.overContent = this.contentss.slice(num,this.contentss.length);
        this.contentss = content;
      }
    },
    init(cLen) {
      this.nullImg = false;
      this.columns = [];
      let contentLen = this.contentArr.length;
      if(cLen > 1){
        this.padd = cLen*300 + (cLen-1)*20 + 'px';
      }else{
        this.padd = '100%';
      }
      // 初始化每一列的第一行元素
      for (let i = 0; i < cLen; i++) {
        this.columns.push({columnArr:[this.contentArr[i]]});
      }
      // 对剩余元素的判断，应该放到哪一列
      this.pushElement(cLen,contentLen,cLen);
    },
    pushElement(index,contentLen,clen){
      setTimeout(() =>{
          var column = $('.column'),heightArr=[];
          for (var i = 0; i < column.length; i++) {
            var item = $(column[i]).find('.item'),height=0; 
            $.each(item,function(ind,ele){
              height += $(ele).height();
            })
            heightArr[i] = height;
          }
          var minHeight = Math.min(...heightArr);
          var minIndex = $.inArray(minHeight,heightArr);
          if(this.contentArr[index+30*(this.pageNum-1)]){
            this.columns[minIndex].columnArr.push(this.contentArr[index+30*(this.pageNum-1)]);
          }
          if(index+1 < contentLen){
            this.pushElement(index+1,contentLen,clen);
          }else{
            this.loadingShow = false;
          }
      },1)
    },
    //计算button宽度
    computed () {
      var twid = 0;
      this.contentss.forEach(element => {
        if (element) {
          twid += ((element.name.length * 14) + 40)
        }
      });
      this.width = twid + 10;
    },
    async getContent (ind,live) {
      var url = '/zciid-deliverable/api/search/datax.json',data,one=[],_this = this;
      if(_this.brush == 2){
        //客户端会员入口
        data={
          pfId:_this.pfId,
          dataType:'chat',
          sort: _this.showFilter == -1 ? '' : _this.showFilter,
          friendId:_this.chooseBusiness.num==0?_this.chooseBusiness.userId: (_this.chooseBusiness.num ==1 ? '' : _this.getQuery('zzBlockId')),
          zxBlockId:_this.chooseBusiness.num==1?_this.chooseBusiness.id: (_this.chooseBusiness.num ==0 ? '' : _this.getQuery('zxBlockId')),
          type:  _this.thirdArray.join(','),
          keyWord: _this.hasKeyword ? _this.keyWord : '',
          pageSize: 30,
          pageNum: _this.pageNum,
          userId:_this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : ''
        }
        if(_this.serialize){
          url = '/zciid-deliverable/api/search/bind/data.json';
          data = {
            mainId:_this.serialize,
            pageSize: 30,
            pageNum: _this.pageNum,
          }
        }
        one = await _this.$http.get(url, data);
        var array = {state:one.state,data:[]};
        if(one.state == 1 && one.data.list.length){
          one.data.list.forEach((ele) => {
            var newObject = {};
            newObject.appId = ele.appId;
            newObject.appName = ele.appName;
            newObject.blockId = '';
            newObject.nodeId = '';
            newObject.contentId = ele.id;
            newObject.contentRows = '';
            newObject.contentShowFlowPosition = '';
            newObject.contentShowRowsSort = '';
            newObject.sceneGroupId = '';
            newObject.sceneId = '';
            newObject.isYyz = 0;
            newObject.userId = '';
            newObject.contentWzUrl = ele.url;
            newObject.blockDataType = '';
            newObject.releaseId = '';
            newObject.sign = '';
            newObject.photo = ele.appPhoto || ele.userPhoto;
            newObject.userName = ele.userName || ele.appName;
            newObject.standardJson = [{ 'standardName': '名称', 'standardData': ele.name, 'fileTypeDetail': '', 'standardType': 0, 'isShow': 1 }, { 'standardName': '头像', 'standardData': ele.photo, 'fileTypeDetail': '2' },{ 'standardName': '简介', 'standardData': ele.intro, 'fileTypeDetail': '', 'standardType': 0, 'isShow': 1 }];
            array.data.push(newObject);
          })
        }
        processing(array,ind);
        return;
      }else if(_this.brush == 1){
        url = '/zciid-deliverable/api/showPlatform/content/getWzFloorBrushContent.json';
        data = {
          appId:_this.getQuery('appId'),
          flowId: Object.keys(_this.chooseBusiness).length ? '' : _this.getQuery('floorflowId'),
          isMedia:_this.getQuery('isMedia'),
          pfId:_this.pfId,
          sort:_this.showFilter,
          zzBlockId:_this.chooseBusiness.num==0?_this.chooseBusiness.id: (_this.chooseBusiness.num ==1 ? '' : _this.getQuery('zzBlockId')),
          zxBlockId:_this.chooseBusiness.num==1?_this.chooseBusiness.id: (_this.chooseBusiness.num ==0 ? '' : _this.getQuery('zxBlockId')),
          type:  _this.thirdArray.join(','),
          keyWord: _this.hasKeyword ? _this.keyWord : '',
          pageSize: 30,
          pageNum: _this.pageNum,
          newAppId:Object.keys(_this.chooseBusiness).length ? _this.getQueryUrl(_this.chooseBusiness.flowUrl,'appId')  : _this.getQuery('newAppId')};
      }
      console.log(_this.serialize);
      
      
      _this.$http
        .get(url, data).then(res => {
          processing(res,ind);
        }).catch(function(error){
          _this.loadingShow = false;
        })
        function processing(res,ind){
          if (res.state == 1 && res.data.length) {
            if(res.data.length < 30){
              _this.loadEnd = false;
            }
            if(_this.brush && ind == 'change'){
              _this.pageNum = 1;
              _this.loadEnd = true;
              _this.contentArr = [];
              _this.columns = [];
            }
            var pDataArr = res.data;
            
            pDataArr.forEach((pData, index) => {
              var tags = [];
              var pictures = [];
              var others = [];
              var btns = [];
              var introduction = '';
              if (!pData || !pData.standardJson) {
                return false;
              } else {
                pData.standardJson.forEach((ele) => {
                  // if(ele.isShow!='0'){
                  if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0 || ele.fileTypeDetail == '2')) {
                    pictures.push(ele.standardData);
                  } else if (ele.standardType == 0) {
                    others.push(ele);
                  } else if (ele.standardType == 3) {
                    btns.push(ele);
                  }
                  // }
                  if (ele.isShow == 1 && ele.standardType != 3) {
                    tags.push(ele);
                  }
                  if (ele.standardName == '简介') {
                    introduction = ele.standardData;
                  }
                });
              }
              _this.contentArr.push({
                appId: pData.appId,
                appName: pData.appName,
                contentId:pData.contentId,
                contentShowRowsSort: pData.contentShowRowsSort,
                sceneId: pData.sceneId,
                contentId: pData.contentId,
                blockId: pData.blockId,
                sceneGroupId: pData.sceneGroupId,
                pictures: pictures.splice(0, 4),
                others: others.splice(0, 5),
                btns: btns.splice(0, 2),
                tags: tags.splice(0, 9),
                nodeId: pData.nodeId,
                contentWzUrl: pData.contentWzUrl,
                contentDsfWzUrl: pData.contentDsfWzUrl ? pData.contentDsfWzUrl : '',
                subDomain: pData.subDomain,
                ind: index,
                introduction: introduction,
                sign: pData.sign,
                meetingId: pData.meetingId,
                communicationId: pData.communicationId,
                show:true,
                standardJson:pData.standardJson,
                photo : pData.photo,
                userName : pData.userName,
                pData:pData
              })
              console.log( _this.contentArr);
              
            })
            if(_this.pageNum == 1){
              _this.init(_this.numss);
            }else{
              _this.pushElement(0,res.data.length);
            }
          } else {
            if (ind == 'change'||_this.pageNum == 1) {
              _this.nullImg = true;
              _this.contentArr = [];
              _this.columns = [];
            }
            _this.loadEnd = false;
            _this.loadingShow = false;
          }
        }
    },
    jumpFlow (ite) {
      this.$blockGetData.handleDetail(this, ite, this.getQuery('floorflowId'));
    }
  }
}
</script>
<style lang="scss" scoped>
.column .item {
  position: relative;
}
.currs{
  background-color: #d0e6ff;
}
.icons{
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 100%;
  background-color: #ececec;
  text-align: center;
}
.suspend{
 display: flex;
 flex-direction: column; 
 background: #fff;
 width: 122px;
 border: 1px solid #ededed;
 font-size: 14px;
 color: #333;
 z-index: 9;
}
.suspend li{
  height: 28px;
  line-height: 28px;
  padding-left: 10px;
}
.titles-brush{
  padding-top: 10px;
  height: 66px !important;
}
.titles{
  height:98px;
  background: #fff;
  padding-bottom: 10px;
  box-sizing:border-box;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.16);
  .navigation{
    width: 100%;
    height: 32px;
    // margin-bottom: 10px;
    .Highlight{
      background-color:#eaf3fd;
      color: #1667b8;
    }
    span{
      display: inline-block;
      line-height: 32px;
      font-size: 14px;
      cursor: pointer;
    }
    .navigation-ite{
      padding: 0 15px;
      &:hover{
        background-color:#eaf3fd;
        color: #1667b8;
      }
    }
    .backGroundColor{
      background-color: #eaf3fd;
    }
    .navigation-more{
      width: 46px;
      height: 32px;
      position: relative;
      background: url("../assets/image/images/icons/more_brush.png") no-repeat center center;
      ul{
        position: absolute;
        top: 32px;
        right: 0;
        z-index: 999;
        background-color: #fff;
        width: 130px;
        height: 170px;
        border: 1px solid #ddd;
        li{
          height: 32px;
          width: calc(100% - 20px);
          line-height: 32px;
          padding: 0 10px; 
          &:hover{
            background-color:#eaf3fd;
            color: #1667b8;
          }
        }
      }
    }
    .navigation-more-hover{
      background: url("../assets/image/images/icons/more_blue_brush.png") no-repeat center center;
    }
  }
}
.searchBox{
  margin:0 auto;
  width:800px;
  height:40px;
  position:relative;
  border-radius:20px;
  border:1px solid #ddd;
  position: relative;
  font-size: 14px;
}
.searchBox.drop{
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.searchBox .filterCriteria{
  position: absolute;
  top: 38px;
  left: -1px;
  z-index: 9999;
  width: calc(100% + 2px);
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.filterCriteria-t{
  width: 100%;
  height: 45px;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}
.filterCriteria-t-scroll{
  position: absolute;
}
.filterCriteria-t-l{
  display: inline-block;
  font-size: 14px;
  color: #333;
  height: 44px;
  line-height: 44px;
  padding: 0 6px;
  margin-right: 10px;
  cursor: pointer;
  box-sizing: border-box;
}
.filterCriteria-t-l.choose{
  color: #0c78cf;
  border-bottom: 1px solid #0c78cf;
}
.filterCriteria-c{
  margin: 3px 0 0;
  max-height: 182px;
  overflow: auto;
  border-bottom: 1px dashed #ddd;
  ul{
    flex: 1;
  }
}
.filterCriteria-c-l{
  margin: 5px 8px 5px 0;
  height: 26px;
  line-height: 26px;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  &:hover{
    background-color: #0c78cf;
    color: #fff;
  }
}
.filterCriteria-c-l.choose{
  background-color: #0c78cf;
  color: #fff;
}

.filterCriteria-c-l.hover:hover{
  background-color: #fff;
  color: #666;
}
.filterCriteria-c-m{
  display: inline-block;
  text-align: right;
  font-size: 14px;
  color: #333;
  margin: 8px 8px 0 0;
  height: 28px;
}
.searchBox .screen{
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 70px;
  border-right: 1px solid #ddd;
  margin: 4px 0 5px 20px;
  box-sizing: border-box;
  cursor: pointer;
  background: url("../assets/image/images/icons/expand.png") no-repeat 36px center;
}
.searchBox .screen.choose{
  color: #0d78cf;
  background: url("../assets/image/images/icons/retract.png") no-repeat 36px center;
}
.searchBox .search{
  position: absolute;
  display: inline-block;
  right: 24px;
  top: 12px;
  background: url("../assets/images/icons/search_blue_16.png") no-repeat;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  cursor: pointer;
}
.searchBox input{
  width:calc(100% - 155px);
  height:calc(100% - 2px);
  margin-left:16px;
  border:0;  
  font-size: 14px;
  color:#333;
}
.searchBox input::-webkit-input-placeholder{
  color:#999;
}
.searchBox input:-moz-placeholder{
  color:#999;
}
.searchBox input::-moz-placeholder.searchBox{
  color:#999;
}
.searchBox input::-ms-input-placeholder{
  color:#999;
}
.choose-content-box {
  padding: 7px 0px;
  position: relative;
  border-top: none;
  height: 28px;
}
.choose-content-box .choose-title {
  width: 91px;
  position: absolute;
  left: 0px;
  top: 9px;
  font-size: 14px;
  line-height: 26px;
  text-align: right;
}
.choose-content-box ul {
  margin-top: 2px;
  margin-left: 91px;
  height: 24px;
}
.choose-content-box ul li {
  position: relative;
  border-radius: 3px;
  padding-right: 20px;
  float: left;
  margin: 0 5px 8px;
  border: 1px solid #4697f9;
  line-height: 24px;
}
.choose-content-box ul li a {
  display: block;
  line-height: 22px;
  font-size: 14px;
}
.choose-content-box ul li span {
  position: absolute;
  right: 3px;
  top: -3px;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}
.topChangeButton {
  display: flex;
  width: 100%;
}

.center {
  width: 100%;
  position: relative;
}
.center ul{
  position: absolute;
  right: 0;
  top: 48px;
}
.center:hover .arrow-left {
  display: block;
}
.center:hover .arrow-right {
  display: block;
}
.arrow-left {
  display: none;
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url("~@/assets/image/images/tab_left_arrow.png") no-repeat center;
  cursor: pointer;
}
.arrow-right {
  display: none;
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url("~@/assets/image/images/tab_right_arrow.png") no-repeat center;
  cursor: pointer;
}
.titles li {
  float: left;
}
.titles li a {
  display: block;
  padding: 0 8px;
  font-size: 14px;
  color: #333;
}
.titles li.curr {
  border-bottom: 1px solid #0c78cf;
}
.titles li.curr a {
  color: #0c78cf;
}
@media screen   and (max-width: 768px) {
  .topChangeButton {
    width: 100%;
  }
}
.topContent {
  height: 100%;
  height: calc(100% - 98px);
  overflow: auto;
  background-color: #efefef;
}
.topContent-null{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.topContent-brush{
  height:calc(100% - 66px);
}
.topContent em{
  margin-top: 40px;
}
.topContent em span{
  font-size: 14px;
  color: #333;
}
.topContent em span:nth-child(2){
  color: #0d78cf;
  cursor: pointer;
}
.loading {
    width: 100%;
    height: 40px;
    text-align: center;
    margin-top: 0;
  }
.contentShow {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  transition: all 0.5s ease;
  > div {
    width:300px;
    .item{
      margin-top: 15px;
      box-shadow: 0px 0px 10px 0px rgba(7, 7, 7, 0.16);
      border-radius: 4px;
      overflow: hidden;
    }
  }
  .brushImages {
    width: 100%;
    // min-height:136px;
    background-color: #e4e4e4;
    text-align: center;
    overflow: hidden;
    font-size: 0;
    // max-height:180px;
    cursor: pointer;
    img {
      min-height: 136px;
      max-height: 180px;
    }
  }
  .back{
    background: url('../assets/image/images/default_media.png') no-repeat center center;
    background-color:#e4e4e4;
  }
  .content {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: #fff;
    border-radius: 0 0 2px 2px;
    > span:first-child {
      display:inline-block;
      font-size: 14px;
      color: #333;
      padding-bottom: 3px;
      height: 18px;
      line-height: 18px;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      &:hover{
        color:#2f8eed;
      }
    }
    > span {
      color:#666;
      font-size: 12px;
      line-height: 18px;
      padding-bottom: 8px;
      text-align: justify;
      max-height: 48px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      cursor: pointer;
      &:hover{
        color:#2f8eed;
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .column{width: 100% !important;padding:0 10px;box-sizing:border-box;}
  .brushImages{height: 150px;}
  .arrow-left { display: block;}
  .arrow-right { display: block;}
  video{height: 100%;}
  .brushImages img {
    object-fit: cover !important
  }
}
@media screen and (max-width: 819px) {
  .searchBox{
    width: calc( 100% - 20px );
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/deliverableDetailChat.vue